// extracted by mini-css-extract-plugin
export var cardHeader = "_ts-0";
export var reorderHandle = "_ts-3";
export var titleArea = "_ts-1";
export var titleAreaWithHandle = "_ts-2";